import { render, staticRenderFns } from "./CalculateSalaryList.vue?vue&type=template&id=47993090&scoped=true&"
import script from "./CalculateSalaryList.vue?vue&type=script&lang=js&"
export * from "./CalculateSalaryList.vue?vue&type=script&lang=js&"
import style0 from "./CalculateSalaryList.vue?vue&type=style&index=0&id=47993090&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47993090",
  null
  
)

export default component.exports